(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["drivetribe-description"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function() {
  $(".video").on("click", function(){
    var $this = $(this),
        videoSrc = $this.data("video-src"),
        iframe = '<iframe src="' + videoSrc + '" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';

    $this.addClass("player").html(iframe);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["referral-faqs"] && !Shopify.designMode) return;
  try {
    
var acc = document.getElementsByClassName("accordion-faq");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("acc-active");
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["referral-menu"] && !Shopify.designMode) return;
  try {
    
// When the user scrolls the page, execute myFunction
window.onscroll = function() {myFunction()};

// Get the header
var header = document.getElementById("ref-menu");

// Get the offset position of the navbar
var sticky = header.offsetTop;

// Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
function myFunction() {
  if (window.pageYOffset > sticky) {
    header.classList.add("sticky");
  } else {
    header.classList.remove("sticky");
  }
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-faqs"] && !Shopify.designMode) return;
  try {
    
var acc = document.getElementsByClassName("accordion-faq");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("acc-active");
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
